var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReleaseNoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14403",
    "data-name": "Group 14403",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0 0)",
    fill: "rgba(65,81,166,0.13)",
    stroke: "#4151a6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11466",
    "data-name": "Path 11466",
    d: "M0,0H24V24H0Z",
    transform: "translate(7.903 8.239)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16872",
    "data-name": "Group 16872",
    transform: "translate(-2.733 -2.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11467",
    "data-name": "Path 11467",
    d: "M4,16.065a10.725,10.725,0,0,1,9.384,9.384,8.044,8.044,0,0,0,4.022-6.7A12.065,12.065,0,0,0,25.45,8.022,4.022,4.022,0,0,0,21.428,4,12.065,12.065,0,0,0,10.7,12.044,8.044,8.044,0,0,0,4,16.065",
    transform: "translate(7.92 8.239)",
    fill: "#fff",
    stroke: "#4151a6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11468",
    "data-name": "Path 11468",
    d: "M8.039,14a8.044,8.044,0,0,0-4.022,8.044,8.044,8.044,0,0,0,8.044-4.022",
    transform: "translate(7.903 11.645)",
    fill: "#fff",
    stroke: "#4151a6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11469",
    "data-name": "Path 11469",
    d: "M15.341,9.341,14,9.341A1.341,1.341,0,1,0,15.341,8,1.341,1.341,0,0,0,14,9.341",
    transform: "translate(11.326 9.601)",
    fill: "#fff",
    stroke: "#4151a6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseNoteIcon);
export default __webpack_public_path__ + "static/media/release_note_icon.9b1758b2be6ca27ac388e93ebd395c34.svg";
export { ForwardRef as ReactComponent };